import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import VisitService from '../services/VisitService';
import PatientService from '../services/PatientService';
import DoctorService from '../services/DoctorService';

const VisitForm = () => {
  const [visit, setVisit] = useState({ patient: '', doctor: '', visitDate: '', items: [] });
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [item, setItem] = useState({ itemName: '', treatmentType: '' });
  const [errors, setErrors] = useState({});

  const treatmentTypes = ["Acupuncture", "Massage", "Cupping", "Moxibustion"];

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    PatientService.getAllPatients().then(res => setPatients(res.data));
    DoctorService.getAllDoctors().then(res => setDoctors(res.data));

    if (id && id !== 'new') {
      VisitService.getVisitById(id).then(res => setVisit(res.data));
    }
  }, [id]);

  const handleChange = (e) => setVisit({ ...visit, [e.target.name]: e.target.value });
  const handleItemChange = (e) => setItem({ ...item, [e.target.name]: e.target.value });

  const addItem = () => {
    const errs = {};
    if (!item.itemName) errs.itemName = "Item Name is required";
    if (!item.treatmentType) errs.treatmentType = "Treatment Type is required";
    setErrors(errs);
    if (Object.keys(errs).length === 0) {
      setVisit({ ...visit, items: [...visit.items, item] });
      setItem({ itemName: '', treatmentType: '' });
    }
  };

  const removeItem = (index) => {
    const newItems = [...visit.items];
    newItems.splice(index, 1);
    setVisit({ ...visit, items: newItems });
  };

  const editItem = (index) => {
    setItem({ ...visit.items[index] });
    removeItem(index);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = {};
    if (!visit.patient) errs.patient = "Patient is required";
    if (!visit.doctor) errs.doctor = "Doctor is required";
    if (!visit.visitDate) errs.visitDate = "Date is required";
    if (visit.items.length === 0) errs.items = "At least one visit item is required";
    setErrors(errs);

    if (Object.keys(errs).length === 0) {
      if (id && id !== 'new') {
        VisitService.updateVisit(id, visit).then(() => navigate('/visits'));
      } else {
        VisitService.createVisit(visit).then(() => navigate('/visits'));
      }
    }
  };

  return (
    <div className="container mt-4">
      <h2>{id && id !== 'new' ? 'Edit Visit' : 'Schedule Visit'}</h2>
      <form onSubmit={handleSubmit}>
        {/* Patient */}
        <div className="mb-3">
          <label>Patient</label>
          <select name="patient" value={visit.patient} onChange={handleChange} className="form-select">
            <option value="">Select Patient</option>
            {patients.map(p => <option key={p.patientID} value={p.patientID}>{p.firstName} {p.lastName}</option>)}
          </select>
          {errors.patient && <div className="text-danger">{errors.patient}</div>}
        </div>

        {/* Doctor */}
        <div className="mb-3">
          <label>Doctor</label>
          <select name="doctor" value={visit.doctor} onChange={handleChange} className="form-select">
            <option value="">Select Doctor</option>
            {doctors.map(d => <option key={d.doctorID} value={d.doctorID}>{d.firstName} {d.lastName}</option>)}
          </select>
          {errors.doctor && <div className="text-danger">{errors.doctor}</div>}
        </div>

        {/* Date */}
        <div className="mb-3">
          <label>Date</label>
          <input type="datetime-local" name="visitDate" value={visit.visitDate} onChange={handleChange} className="form-control"/>
          {errors.visitDate && <div className="text-danger">{errors.visitDate}</div>}
        </div>

        {/* Items */}
        <h5>Visit Items</h5>
        {errors.items && <div className="text-danger mb-2">{errors.items}</div>}
        <div className="mb-3">
          <input type="text" name="itemName" placeholder="Item name" value={item.itemName} onChange={handleItemChange} className="form-control mb-2"/>
          {errors.itemName && <div className="text-danger">{errors.itemName}</div>}

          <select name="treatmentType" value={item.treatmentType} onChange={handleItemChange} className="form-select mb-2">
            <option value="">Select Treatment Type</option>
            {treatmentTypes.map((type, idx) => <option key={idx} value={type}>{type}</option>)}
          </select>
          {errors.treatmentType && <div className="text-danger">{errors.treatmentType}</div>}

          <button type="button" className="btn btn-secondary mb-3" onClick={addItem}>Add Item</button>
        </div>

        <ul className="list-group mb-3">
          {visit.items.map((it, idx) => (
            <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
              {it.itemName} - {it.treatmentType}
              <div>
                <button type="button" className="btn btn-sm btn-warning me-2" onClick={() => editItem(idx)}>Edit</button>
                <button type="button" className="btn btn-sm btn-danger" onClick={() => removeItem(idx)}>Delete</button>
              </div>
            </li>
          ))}
        </ul>

        <button type="submit" className="btn btn-primary w-100">Save Visit</button>
      </form>
    </div>
  );
};

export default VisitForm;
